import { render, staticRenderFns } from "./myCoupon.vue?vue&type=template&id=53ab33f4&scoped=true"
import script from "./myCoupon.vue?vue&type=script&lang=js"
export * from "./myCoupon.vue?vue&type=script&lang=js"
import style0 from "./myCoupon.vue?vue&type=style&index=0&id=53ab33f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ab33f4",
  null
  
)

export default component.exports